import React, { useState, useEffect } from 'react'
import { getListSewingRepairInBatch, exportListSewingRepairInBatch, exportListEmbroideryError, getListEmbroideryError } from '../../../services/api/3dApi'
import { Link } from 'react-router-dom'
import { Icon, Pagination, Select, Button, Spin, message, AutoComplete, Input } from 'antd'
import { getListBrand } from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import UseDebounce from '../../users/helpers/UseDebounce'
import {createJobExport} from '../../../helpers/createJobExport'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'
import EmbroideryErrorInBatchTable from './EmbroideryErrorInBatchTable'
import QueryString from 'qs'
import { ERROR_EMBROIDERED } from "../../batches-mark-qc-v3/contant/ListOption.json"

function EmbroideryErrorInBatchPage() {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listEmbroideryError, setListEmbroideryError] = useState([])
    const [type, setType] = useState([])
    const [errorType, setErrorType] = useState('')
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [markErrorAt, setMarkErrorAt] = useState({})

    const debounceError = errorType === '' ? UseDebounce(errorType, 0) : UseDebounce(errorType, 500)

    const fetchEmbroideryError = async () => {
        setLoading(true)

        try {
            const query = Object.assign({}, {
                status: ["pending", "done"],
                sku: !!type.length ? type : [],
                type_error: !!errorType ? [errorType] : [],
                mark_error_at: !!Object.keys(markErrorAt).length ? markErrorAt : [],
                brand_name: !!brand.length ? brand : [],
            })

            const params = QueryString.stringify({ query, page, limit })
            const { data: res } = await getListEmbroideryError(params)

            const { data, success, message: mess } = { ...res }

            if (success) {
                setListEmbroideryError(data.items)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const _getListBrandEmbroidery = async () => {
        const payloadBrand = {
            page: 1,
            limit: 10000
        }
        try {
            const { data: Data } = await getListBrand(payloadBrand)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }

    const handleChangeErrorType = (value) => {
        setErrorType(value)
        setPage(1)
    }

    const handleChangeMarkErrorAt = (field, value) => {
        setMarkErrorAt(value)
        setPage(1)
    }
    
    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const exportEmbroideryError = async () => {
        setLoading(true)
        setError('')

        try {
            const query = {
                status: ["pending", "done"],
            }

            if (type.length) query.sku = type
            if (!!errorType) query.type_error = [errorType]
            if (Object.keys(markErrorAt).length) query.mark_error_at = markErrorAt
            if (brand.length) query.brand_name = brand

            const payloadE = {
                page: page,
                limit: limit,
                query: query
            }
            
            const { data: res } = await exportListEmbroideryError(payloadE)

            if(typeof res !== 'string'){
                const { success, message: mess, data } = res
                if(!success) throw new Error(mess)
            
                if(Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            }else{
                if(res) downloadFileFromData(res, { filename: `embroidery-error-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }finally{
            setLoading(false)
        }
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    useEffect(() => {
        fetchEmbroideryError()
    }, [limit, page, type, brand, debounceError, markErrorAt])

    useEffect(() => {
        _getListBrandEmbroidery()
    }, [])

    const { Option } = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')

    return (
        <div className='EmbroideryErrorInBatchPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Thống kê item lỗi thêu</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportEmbroideryError}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='embroidery-error'
                                disabled={loading}
                            >
                                Items lỗi thêu
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label htmlFor="error_type" className="Error font-weight-bold mb-1">Loại lỗi:</label>
                                <AutoComplete
                                    options={ERROR_EMBROIDERED}
                                    dataSource={ERROR_EMBROIDERED}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeErrorType}
                                    allowClear
                                    placeholder="Search loại lỗi"
                                    className='w-100'
                                >
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label className="font-weight-bold mb-1">Ngày báo lỗi</label>
                                <FilterDateRangeV2
                                    field='mark_error_at'
                                    onDatesChange={handleChangeMarkErrorAt}
                                />
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label for="request_update" className="d-block w-100 font-weight-bold mb-1">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{ width: '100%' }}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <EmbroideryErrorInBatchTable
                            listEmbroideryError={listEmbroideryError}
                            setType={setType}
                            setBrand={setBrand}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default EmbroideryErrorInBatchPage